// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.landlord.UndoMarkOneTimePaymentAsPaidOfflineWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UndoMarkOneTimePaymentAsPaidOfflineWebApiRequestDto } from '../..';

export const UndoMarkOneTimePaymentAsPaidOfflineWebApiHandler_undoMarkOneTimePaymentAsPaidOffline_Path =
  '/api/web/v1/landlord/undoMarkOneTimePaymentAsPaidOffline';

/**
 * Undo a one-time payment or move-in costs group previously marked as received offline by the landlord
 */
export const UndoMarkOneTimePaymentAsPaidOfflineWebApiHandler_undoMarkOneTimePaymentAsPaidOffline = (
  postData: UndoMarkOneTimePaymentAsPaidOfflineWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UndoMarkOneTimePaymentAsPaidOfflineWebApiRequestDto, void>(
    {
      endpoint: UndoMarkOneTimePaymentAsPaidOfflineWebApiHandler_undoMarkOneTimePaymentAsPaidOffline_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
